import { ReactNode } from 'react';
import { Label, Value } from './styles';

export interface LineItemProps {
  label: string;
  value?: string | ReactNode;
}
const LineItem = ({ label, value }: LineItemProps) => {
  return (
    <div>
      <Label>{label}</Label>
      <Value>{value || '-'}</Value>
    </div>
  );
};

export default LineItem;
